/* Vornom redesign (D1 = b): blog post (sections/vor-article).
   - Table of contents: built from the body's h2[id] headings (Vornom's assets/vornom-blog.js, same rules): shown only
     with 3 or more headings; the current section (the last heading above the line) is marked with aria-current and
     kept in view in a long list.
   - "Bağlantıyı kopyala": copies the post URL and says so in a live region. */
(function () {
  var body = document.querySelector('.vor-art__body');
  var aside = document.querySelector('.vor-art__toc');
  if (body && aside) {
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2[id]'));
    if (heads.length >= 3) {
      var list = aside.querySelector('ol');
      var links = heads.map(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
        return a;
      });
      aside.hidden = false;

      var active = null;
      var box = aside.querySelector('.vor-art__toc-box');
      var mark = function (a) {
        if (active === a) return;
        if (active) active.removeAttribute('aria-current');
        active = a;
        if (!active) return;
        active.setAttribute('aria-current', 'true');
        if (box && box.scrollHeight > box.clientHeight) {
          var top = active.offsetTop - box.clientHeight / 2;
          box.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      };
      var LINE = 120;
      var update = function () {
        var current = 0;
        for (var i = 0; i < heads.length; i++) {
          if (heads[i].getBoundingClientRect().top <= LINE) current = i;
          else break;
        }
        mark(links[current]);
      };
      var queued = false;
      var schedule = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; update(); });
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      update();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vor-copy-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-vor-copy-link');
    var status = document.querySelector('[data-vor-copy-status]');
    var done = function () {
      if (status) status.textContent = btn.getAttribute('data-vor-copied') || 'Kopyalandı';
      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); if (status) status.textContent = ''; }, 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Bağlantı:', url); });
    } else {
      window.prompt('Bağlantı:', url);
    }
  });
})();
